import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { usePermissions } from 'components/providers/PermissionProvider'
import {
  hasPermission,
  subscriptionsFreeTimePermission,
  subscriptionsSubscriptionsPermission,
  subscriptionsPermitsPermission,
  subscriptionsSubscriptionOffersPermission,
} from 'utils'
import * as permissionType from '../../constants/permissions'
import { ROUTE } from 'constants/Routes'
import Home from 'components/views/subscriptions/buy/views/home/Home'
import PurchaseSteps from 'components/views/subscriptions/buy/views/purchase-steps/PurchaseSteps'
import SpecialRates from 'components/views/subscriptions/special-rates/SpecialRates'
import Subscriptions from 'components/views/subscriptions/subscriptions/Subscriptions'
import Permits from 'components/views/subscriptions/permits/Permits'
import SubscriptionOffers from 'SubscriptionOffers/SubscriptionOffers'

export default withRouter(({ history }) => {
  const permissions = usePermissions()

  const hasBuyPermission = hasPermission(permissions, permissionType.PAGE_SUBSCRIPTIONS_BUY),
    hasFreeTimePermission = subscriptionsFreeTimePermission(permissions),
    hasSubscriptionsPermission = subscriptionsSubscriptionsPermission(permissions),
    hasPermitsPermission = subscriptionsPermitsPermission(permissions),
    hasSubscriptionOffersPermission = subscriptionsSubscriptionOffersPermission(permissions)

  const NAV = [
    hasSubscriptionsPermission && {
      uri: ROUTE.SUBSCRIPTIONS.SUBSCRIPTIONS,
    },
    hasBuyPermission && {
      uri: ROUTE.SUBSCRIPTIONS.HOME,
    },
    hasFreeTimePermission && {
      uri: ROUTE.SUBSCRIPTIONS.FREE_TIME,
    },
    hasPermitsPermission && {
      uri: ROUTE.SUBSCRIPTIONS.PERMITS,
    },
    hasSubscriptionOffersPermission && {
      uri: ROUTE.SUBSCRIPTIONS.SUBSCRIPTION_OFFERS,
    },
  ].filter(el => el)

  if (history.location.pathname == ROUTE.SUBSCRIPTIONS.MAIN && NAV.length && NAV[0]) {
    return <Redirect to={NAV[0].uri} />
  }

  return (
    <Switch>
      {hasBuyPermission && (
        <Route path={ROUTE.SUBSCRIPTIONS.HOME}>
          <Home />
        </Route>
      )}
      {hasBuyPermission && (
        <Route path={ROUTE.SUBSCRIPTIONS.BUY}>
          <PurchaseSteps />
        </Route>
      )}
      {hasFreeTimePermission && (
        <Route path={ROUTE.SUBSCRIPTIONS.FREE_TIME}>
          <SpecialRates />
        </Route>
      )}
      {hasSubscriptionsPermission && (
        <Route path={ROUTE.SUBSCRIPTIONS.SUBSCRIPTIONS}>
          <Subscriptions />
        </Route>
      )}
      {hasPermitsPermission && (
        <Route path={ROUTE.SUBSCRIPTIONS.PERMITS}>
          <Permits />
        </Route>
      )}
      {hasSubscriptionOffersPermission && (
        <Route path={ROUTE.SUBSCRIPTIONS.SUBSCRIPTION_OFFERS}>
          <SubscriptionOffers />
        </Route>
      )}
    </Switch>
  )
})
